/**
 * Dashboard Service
 *
 * Provides API calls for role-based dashboard data
 */

import { apiGet } from '@/utils/api';
import type {
  DashboardResponse,
  FinanceWidget,
  ChildAbsence,
} from '@/types/dashboard.types';

/**
 * Get dashboard stats based on user role
 * The backend automatically routes to the appropriate dashboard based on JWT
 */
export async function getDashboardStats(academicYearId?: string): Promise<DashboardResponse> {
  const qs = academicYearId ? `?academicYearId=${academicYearId}` : '';
  return apiGet<DashboardResponse>(`/dashboard/stats${qs}`);
}

/**
 * Get finance widget data for student
 * Used by Student dashboard to display financial information
 */
export async function getStudentFinanceWidget(): Promise<FinanceWidget | null> {
  return apiGet<FinanceWidget | null>('/dashboard/finance');
}

/**
 * Get child absences for parent
 * Returns weekly and monthly absence counts per child
 */
export async function getChildAbsences(): Promise<ChildAbsence[]> {
  return apiGet<ChildAbsence[]>('/dashboard/child-absences');
}

// Export all functions as a service object for consistency
export const dashboardService = {
  getDashboardStats,
  getStudentFinanceWidget,
  getChildAbsences,
};
